module.exports = __webpack_public_path__ + "img/Transportationnoselected.fc65eb79.jpg";